import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-three-columns-four-page',
  templateUrl: './courses-grid-style-three-columns-four-page.component.html',
  styleUrls: ['./courses-grid-style-three-columns-four-page.component.scss']
})
export class CoursesGridStyleThreeColumnsFourPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
